import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSideNavigation, NamedLink } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import bannerImage from './Banner.jpg';
import { useConfiguration } from '../../context/configurationContext';

import css from './AboutPage.module.css';

export const AboutPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const { marketplaceName } = useConfiguration();
  const title = intl.formatMessage({ id: 'AboutPage.metaTitle' }, { marketplaceName });
  const description = intl.formatMessage({ id: 'AboutPage.metaDescription' }, { marketplaceName });

  return (
    <Page title={title} description={description} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="AboutPage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              isWhiteBgNav={false}
              isHeaderSticky={true}
            />
          </>
        }
        hideCssMainClass
        sideNav={null}
        currentPage="AboutPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <img src={bannerImage} alt={intl.formatMessage({ id: 'AboutPage.imageAlt' })} />
          <h1>
            <FormattedMessage id="AboutPage.heading" />
          </h1>
          <p>
            <FormattedMessage id="AboutPage.introduction" />
          </p>
          <h2>
            <FormattedMessage id="AboutPage.guestHeading" />
          </h2>
          <p>
            <FormattedMessage id="AboutPage.guestDescription" />
          </p>
          <p>
            <NamedLink name="SearchPage">
              <FormattedMessage id="LandingPage.browseLink" />
            </NamedLink>
          </p>
          <h2>
            <FormattedMessage id="AboutPage.hostHeading" />
          </h2>
          <p>
            <FormattedMessage id="AboutPage.hostDescription" />
          </p>
          <p>
            <NamedLink name="NewListingPage">
              <FormattedMessage id="Host.listProperty" />
            </NamedLink>
          </p>
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

AboutPageComponent.defaultProps = {};

AboutPageComponent.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const AboutPage = compose(connect(mapStateToProps, null), injectIntl)(AboutPageComponent);

export default AboutPage;
